import { useState, ReactNode, createContext } from 'react';

interface CacheData {
  [key: string]: number;
}

export const ContentPagesCacheContext = createContext<{
  cache: CacheData;
  setCache: (key: string, value: any) => void;
}>({
  cache: {},
  setCache: () => {},
});

export const ContentPagesCacheProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [cache, setCacheState] = useState<CacheData>({});

  const setCache = (key: string, value: any) => {
    setCacheState((prevCache) => ({
      ...prevCache,
      [key]: value,
    }));
  };

  return (
    <ContentPagesCacheContext.Provider value={{ cache, setCache }}>
      {children}
    </ContentPagesCacheContext.Provider>
  );
};
